






























import Vue from 'vue'
export default Vue.extend({
  name: 'IconNotification',
  props: {
    color: {
      type: String,
      default: 'white',
    },
    showBadge: {
      type: Boolean,
      default: false,
    },
    badgeNumber: {
      type: Number,
      default: 0,
    },
  },
})
